export default __webpack_public_path__ + "static/media/Text(Nobid).b1a93474.svg";